import { appApi } from '@web/app/store/api'
import { IEntitiesResponse } from '../types'

export const entitiesApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getEntities: builder.query<IEntitiesResponse, void>({
      query: () => ({
        url: '/api/v1/entities',
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useGetEntitiesQuery } = entitiesApi
